import { Box, Flex } from 'mds-web-ui'
import { Link as BaseLink } from 'mds-web-ui/components/Link/GatsbyLink'
import React from 'react'

import AppStoreBadge from '../shared/AppStore'
import { GatsbyImage } from 'gatsby-plugin-image'

export const Link = ({ ...props }) => (
  <BaseLink
    mb={0}
    fontSize={[2, 18]}
    fontWeight="bold"
    lineHeight={[1.5, 2]}
    color="black"
    display="flex"
    {...props}
  />
)

const FlowLink = props => (
  <Link
    external
    to="https://apps.apple.com/app/apple-store/id1271361459?pt=542023&ct=mdshome&mt=8"
    title="Download Flow by Bonobo on the App store"
    {...props}
  >
    <AppStoreBadge height={48} showBorder={false} />
  </Link>
)

export const FlowWebLink = ({ flowIconImage, ...props }) => {
  return (
    <Link
      external
      to="https://flowapp.moleskinestudio.com"
      title="Use Flow on Web"
      {...props}
    >
      <Flex
        height={48}
        css={{ gap: 12, borderRadius: 8 }}
        alignItems="center"
        justifyContent="center"
        bg="#000"
        color="#fff"
        pl={2}
        pr={10}
      >
        <Box width={36} height={36}>
          <GatsbyImage image={flowIconImage} alt="Flow icon" />
        </Box>
        <Box css={{ fontWeight: 500, fontSize: 20, lineHeight: 1 }}>
          Flow Web
        </Box>
      </Flex>
    </Link>
  )
}

export const FlowLinks = ({ flowIconImage, ...props }) => {
  return (
    <Flex gap={2} {...props}>
      <FlowLink />
      <FlowWebLink flowIconImage={flowIconImage} />
    </Flex>
  )
}

export default FlowLink
